<section id="secao-cultura">
  <div class="container">
    <div class="image-cultura-colaborativa">
      <img src="assets/imagens/cultura-colaborativa.png" />
    </div>
    <div class="title mt-4">
      <h1 class="text-center text-white display-4">Cultura Colaborativa</h1>
    </div>
  </div>
</section>
